import React from "react";
import LogisticsForm from "../components/forms/LogisticsForm";

const Logistics: React.FC = () => {
  return (
   <>
   <LogisticsForm />
   </>
  );
};

export default Logistics;

